
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
components: {
Flexbox,
FlexboxItem,
XButton
},
props: {
value: {
type: Boolean,
default:false
},
},
data () {
return {

visible: false,

loading: false,
croppable: false,
cropper:'',
url:''
}
},
beforeDestroy () {

},

computed: {

},
watch: {
value(val) {
this.visible = val;
},
visible(val) {
this.$emit('input', val);
},
},
mounted() {
if (this.value) {
this.visible = true;
}

this.$nextTick(() => {

var self = this;
var image = document.getElementById('image');
this.cropper = new Cropper(image, {

viewMode: 1,
background:false,
zoomable:false,
minCropBoxWidth: 80,
minCropBoxHeight: 80,
ready: function () {
self.croppable = true;
}
});

})
},
methods: {
getNewUrl(url){

if(this.cropper){
this.cropper.replace(url);
}
},
getObjectURL (file) {
var url = null;
if (window.createObjectURL!=undefined) { // basic
url = window.createObjectURL(file) ;
} else if (window.URL!=undefined) { // mozilla(firefox)
url = window.URL.createObjectURL(file) ;
} else if (window.webkitURL!=undefined) { // webkit or chrome
url = window.webkitURL.createObjectURL(file) ;
}
return url ;
},
crop () {

var croppedCanvas;
var roundedCanvas;

if (!this.croppable) {
return;
}

croppedCanvas = this.cropper.getCroppedCanvas();


roundedCanvas = this.getCompressCanvas(croppedCanvas);


let base64 = roundedCanvas.toDataURL();
this.postImg(base64)
},
getCanvas(sourceCanvas){
var canvas = document.createElement('canvas');
var context = canvas.getContext('2d');
var width = sourceCanvas.width;
var height = sourceCanvas.height;

canvas.width = width;
canvas.height = height;

context.drawImage(sourceCanvas, 0, 0, width, height);
return canvas;
},

getRoundedCanvas (sourceCanvas) {
var canvas = document.createElement('canvas');
var context = canvas.getContext('2d');
var width = sourceCanvas.width;
var height = sourceCanvas.height;

canvas.width = width;
canvas.height = height;

context.imageSmoothingEnabled = true;
context.drawImage(sourceCanvas, 0, 0, width, height);
context.globalCompositeOperation = 'destination-in';
context.beginPath();
context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
context.fill();

return canvas;
},
postImg (base64) {

this.loading = true;
this.$post(this.$rootPath + 'com/logoBase64', base64).then(res => {
let data = res.data;
this.visible = false;
this.$emit('on-crop', data);
}, err=>{

}).then(()=>{
this.loading = false;
})
},
getCompressCanvas(sourceCanvas, w){
w = w || 320;
var canvas = document.createElement('canvas');
var context = canvas.getContext('2d');
var width = sourceCanvas.width > w ? w : sourceCanvas.width;
var height = sourceCanvas.width > w ? w * sourceCanvas.height/sourceCanvas.width : sourceCanvas.height;

canvas.width = width;
canvas.height = height;

context.drawImage(sourceCanvas, 0, 0, width, height);
return canvas;
},
}
}



// WEBPACK FOOTER //
// ./src/components/picCut/picCut.vue